export default __webpack_public_path__ + "static/media/ruLogo-white-theme.6deb8d65.svg";